import { TransformType } from 'src/app/domainObjects/transformType';
import { DataTransform } from 'src/app/domainObjects/dataTransform';
import { TransformRule } from '../transformRule';
import { DataFarmType } from '../dataFarmType';
import { SortInfo } from '../sortInfo';
import { AndOr, AnonType, RuleOptions,WordSepMode } from 'src/app/views/transform/transformerDetail/anonymizer-transform-detail/anonymizerRuleViewModel';
import { ColoredTextItem } from '../coloredTextItem';
import { FindReplace } from '../rowExtractorTransform';

export class AnonymizerTransform extends DataTransform<AnonymizerTransformConfig> {

    constructor(id: number, index: number, name: string,nodeID:string) {
      super(id, name, index, TransformType.anonymizer,nodeID);
      this.transformConfig = new AnonymizerTransformConfig();
    }

    static fromJSON(data: any): AnonymizerTransform {
        //console.log(`fromJson invoked: ${data}`);
        const instance: AnonymizerTransform = Object.assign(new AnonymizerTransform(0, 0, '', ''), data);
        if (instance.transformConfig) {
            instance.transformConfig = AnonymizerTransformConfig.fromJSON(instance.transformConfig);
        }

        return instance;
    }
    
    setRunAll(runAll: boolean): void {
        this.transformConfig.runAll = runAll;
    }
}

export class AnonymizerTransformConfig {
    transformConfigId?: number;
    instance: string;
    farmType: DataFarmType;
    transformType: TransformType;
    sortInfo?: SortInfo[];
    sampleStart: number;
    sampleEnd: number;
    runAll: boolean;
    threads: number;
    fixedTermsName?: string[];
    fixedTermsCategory?: string[];
    fixedTermsLocation?: string[];
    fixedTermsDetails?: string[];
    fixedTermsURL?: string[];
    caseName: boolean=false ;
    caseCategory: boolean=false;
    caseLocation: boolean=false;
    caseDetails: boolean=false;
    caseURL: boolean=false;

    rules: AnonymizerRule[];

    static fromJSON(data: any): AnonymizerTransformConfig {
        //console.log(`fromJson invoked: ${data}`);
        const instance: AnonymizerTransformConfig = Object.assign(new AnonymizerTransformConfig(), data);

        const rules: AnonymizerRule[] = [];
        if (instance.rules) {
            instance.rules.forEach(r => {
                const rule = AnonymizerRule.fromJSON(r);
                rules.push(rule);
            });
        }
        instance.rules = rules;
        return instance;
    }
}

export class AnonymizerRule extends TransformRule {
    fields: string[];
    anonType: AnonType
    preservedTerms: string[];
    mapTerms: FindReplace;
    mapOnly: boolean;
    matchCase: boolean;
    findTerms: string[];
    andOr:AndOr;
    ruleOption:RuleOptions;
    wordSepMode:WordSepMode;

    static fromJSON(data: any): AnonymizerRule {
        //console.log(`fromJson invoked: ${data}`);
        const instance: AnonymizerRule = Object.assign(new AnonymizerRule(), data);

        return instance;
    }
}

